module.exports = __webpack_public_path__ + "img/join-us-5.d83ce210.png";